import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CategoryTreeEntity } from '../+state/category-tree.models';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';

@Injectable({
  providedIn: 'root',
})
export class CategoryTreeService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  performPostRequest(language?: string): Observable<{ categories: CategoryTreeEntity[] }> {
    let url = this.apiData.apiURL + `api/${this.client}/categorytree/de`;
    if (language) {
      url = this.apiData.apiURL + `api/${this.client}/categorytree/` + language;
    }

    // Header erstellen und Token hinzufügen
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // POST-Anfrage mit Header senden
    return this.http.post<{ categories: CategoryTreeEntity[] }>(url, { headers: headers });
  }
}
